import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class InstaService {
  private authRedirectUrl = 'http://localhost:4300/instaAuth';
  private authClientId = 'ed34c53893cc480c9ffdceef038348df';
  private authUrl = `https://api.instagram.com/oauth/authorize/?client_id=${this.authClientId}&redirect_uri=${this.authRedirectUrl}&scope=public_content&response_type=token`;

  get access_token() {
    return localStorage.getItem('insta_token');
  }

  set access_token(token: string) {
    localStorage.setItem('insta_token', token);
  }


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) { }

  startAuth() {
    sessionStorage.setItem('redirectAfterAuth', this.router.url);
    document.location.href = this.authUrl;
  }

  SearchByTag(tag: string) {
    const requestUrl = `https://api.instagram.com/v1/tags/${tag}/media/recent?access_token=${this.access_token}`;
    return this.http.get<any>(requestUrl);
  }

}
